import React from 'react'
import { generateKey } from '../../utils/utils.js'

const HyperLinks = (props) => {
    const { arr, index } = props;

    if (arr.nodeType === "hyperlink") {
        let type = "";

        if (arr.content[0].value.includes('@')) type = "e. ";

        return (
            <p key={generateKey(index)}>
                {type}
                <a style={{ color: 'white' }}
                    href={arr.data.uri}
                    rel="noopener noreferrer"
                    target="_blank">{arr.content[0].value}</a>
            </p>
        )
    } else {
        return null;
    }
}
const Contact = (props) => {
    return (
        props.about[0].fields.contact.content.map((contact, index) => {
            if (contact.content.length > 1) {
                let hypers = contact.content.map((arr, index) => {
                    return <HyperLinks key={generateKey(index)} arr={arr} index={index} />
                })
                return hypers;
            } else {
                return <p key={generateKey(index)}> {contact.content[0].value}</p>
            }
        })
    )
}

export default Contact;